import { API_endpoints } from "../config";

export const deleteWorkBlock = async (ids : (number|undefined)[],bookings : (any)[]) => {
    try {
        const response = await fetch(API_endpoints.deleteWorkBlock, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({  ids,bookings }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Löschen von Block Daten:", error);
        throw error;
    }
};
